import { IAppConfig } from '@estee/elc-universal-utils';
import { action, observable } from 'mobx';
import { INarvarOrderData } from 'src/api/OrderTrackingApiSdk';

export interface IDeliveryMethod {
    methodCode: string;
    methodName: string;
    defaultCarrierCode?: string;
}

export interface ICarrierCode {
    carrierCode: string;
    carrierName: string;
    carrierTrackingUrl: string;
    cutOffTime?: string;
}

// Order status, it should match the keys configured in BUID config
export enum OrderStatusType {
    ORDER_PROCESSING = 'orderProcessing',
    AT_WAREHOUSE = 'atWarehouse',
    SHIPPED = 'shipped',
    DELIVERED = 'delivered',
    RETURN_IN_PROGRESS = 'returnInProgress',
    CANCELLED = 'cancelled',
    DELAYED = 'delayed',
    UNDELIVERABLE = 'Undeliverable'
}

export interface IOrderStatusCode {
    orderStatusMappedType: OrderStatusType;
    showInProgress: boolean;
    indexOfProgress: number;
    orderStatusCodes: string[];
}

export enum OrderNumberType {
    TOID = 'toid',
    TID = 'tid'
}

export interface IOrderStatusLabelMap {
    orderStatusLabel: string;
    orderStatusCode: string[];
}

export interface IOrderTrackingConfig {
    formattedDeliveredDate: string;
    formattedOrderDate: string;
    orderNumberType: OrderNumberType;
    dateFormatPattern: string;
    orderStatusCodeMap: IOrderStatusCode[];
    deliveryMethods: IDeliveryMethod[];
    carrierCodes: ICarrierCode[];
    orderNumberValidationRegex: string;
    orderNumberValidationMaxLength: number;
    isVerticalTMOProgressBarDisplay: boolean;
    orderStatusLabelMap: IOrderStatusLabelMap[];
    breadCrumbDelimiter: IBreadCrumbsDelimiter;
    datetimeFormatPattern?: string;
    narvar_data?: INarvarOrderData;
    SetReturnInitiatedStatusCode?: string;
    dateTimeStampFormatPattern: string;
    partialShipmentStatusCode: string;
}

export interface IBreadCrumbsList {
    label: string;
    href?: string;
}

export interface IOrderDetailStep {
    heading: string;
    description: string;
    statusTimestamp?: string;
}

export interface IConfig extends IAppConfig {
    orderTracking: IOrderTrackingConfig;
    region: { id: string };
    brand: { id: string };
    pgApiTokens: { orderTracking: string };
}

export class Config {
    @observable public config: Partial<IConfig> = {};

    constructor(config: IAppConfig) {
        this.updateConfig(config);
    }

    @action
    updateConfig(config: Partial<IConfig>): void {
        this.config = { ...this.config, ...config };
    }
}

export interface IValidationMessageObject {
    [key: string]: IProgressBarView;
}

export interface IProgressBarView {
    progressBar: string;
    progressBarHeader: string;
    progressBarDesc: string;
    progressBarTimestamp: string;
}

export interface IBreadCrumbsDelimiter {
    forward: string;
    backward: string;
}
